import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, withHandlers } from 'recompose';
import { ChevronRight } from 'components/svg';
import { Link } from 'components/core/Link';
import { setLocation } from 'lib/helpers';
import UnitDetails from './UnitDetails';

import './LinkedUnitDetails.scss';

const enhance = compose(
	withHandlers({
		routeToLinkedUnit: () => (route) => {
			setLocation(route);
		},
	})
);

export function LinkedUnitDetails({
	unit,
	facility,
	showIcon,
}) {
	return (
		<Link
			hideBorder
			className={classnames(
				'linked-unit-details',
				'atomic-linked-unit-details'
			)}
			href={unit?.url || unit?.facilityUrl}
			productClick
		>
			<UnitDetails
				unit={unit}
				facility={{
					showFeeWarning: facility?.showFeeWarning,
					fees: facility?.fees,
					giftCardOffer: facility?.giftCardOffer,
				}}
				showIcon={showIcon}
			/>

			{/* <ChevronRight fill="black" /> */}
		</Link>
	);
}

LinkedUnitDetails.propTypes = {
	unit: PropTypes.shape({
		facilityUrl: PropTypes.string,
		url: PropTypes.string,
		width: PropTypes.number,
		length: PropTypes.number,
		sizeBucket: PropTypes.string,
		unitTypeText: PropTypes.string,
		unitId: PropTypes.number,
	}),
	routeToLinkedUnit: PropTypes.func,
	facilityUrl: PropTypes.string,
	facility: PropTypes.object,
	showIcon: PropTypes.bool,
};

export default enhance(LinkedUnitDetails);
